import WeatherRiskBadge from "../risk/WeatherRiskBadge";
import WeatherConfidenceBadge from "../risk/WeatherConfidenceBadge";

export default function WeatherReportSummaryCard({ summary }) {
  if (!summary) {
    return null;
  }

  return (
    <section className="panel-card weather-report-summary">
      <p className="eyebrow">Executive summary</p>
      <div className="weather-report-summary__badges">
        <WeatherRiskBadge level={summary.riskLevel} />
        <WeatherConfidenceBadge confidence={summary.confidence} />
      </div>
      <p>{summary.executiveSummary}</p>
      {summary.floodAware?.hints?.length ? (
        <ul className="weather-report-summary__flood muted">
          {summary.floodAware.hints.map((hint) => (
            <li key={hint.type}>{hint.message}</li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
